module.exports = __webpack_public_path__ + "corner-364ce09adbd59ebb4019c08817242292.png";